(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["material-product"]) return;
  try {
    
  function initializeTargetScopes(root) {
    root.querySelectorAll('[data-target-scope]').forEach((select) => {
      if (select.dataset.scopeReady) return;
      select.dataset.scopeReady = 'true';
      const update = () => {
        const bare = select.value === 'Bare Target';
        select.form.querySelectorAll('[data-target-assembly]').forEach((group) => {
          group.hidden = bare;
          group.querySelectorAll('input').forEach((input) => { input.disabled = bare; });
        });
      };
      select.addEventListener('change', update);
      update();
    });
  }
  initializeTargetScopes(document);
  document.addEventListener('shopify:section:load', (event) => initializeTargetScopes(event.target));

  } catch(e) { console.error(e); }
})();
})();
